/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';

const dashboards = {
  analytic: lazy(() => import('views/dashboards/DashboardsAnalytic')),
};
const tenants = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  addNew: lazy(() => import('views/tenants/AddNewTenants')),
  addNewSelf: lazy(() => import('views/tenants/AddNewSelfServiceTenant')),
  List: lazy(() => import('views/tenants/TenantList')),
  ViewTenant: lazy(() => import('views/tenants/ViewTenants')),
  EditTenant: lazy(() => import('views/tenants/EditTenants')),
  InActiveTenants: lazy(() => import('views/tenants/InActiveTenants')),
  ActiveTenants: lazy(() => import('views/tenants/ActiveTenants'))
}
const shortStay = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  addNew: lazy(() => import('views/ShortStay/addNewVisitor')),
  List: lazy(() => import('views/ShortStay/visitorList')),
  ViewVisitor: lazy(() => import('views/ShortStay/ViewVisitor')),
  EditVisitor: lazy(() => import('views/ShortStay/editVistor')),
  InActiveTenants: lazy(() => import('views/tenants/InActiveTenants')),
  ActiveTenants: lazy(() => import('views/tenants/ActiveTenants'))
}
const staff = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  addNew: lazy(() => import('views/staff/AddStaff')),
  List: lazy(() => import('views/staff/StaffList')),
  ViewList: lazy(() => import('views/staff/ViewStaff')),
  Edit: lazy(() => import('views/staff/EditStaff'))
}

const selfservice = {
  // index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  // addNew: lazy(()=>import('views/staff/AddStaff')),
  List: lazy(() => import('views/selfService/SelfServiceList')),
  // ViewList: lazy(()=>import('views/staff/ViewStaff')),
  // Edit: lazy(()=>import('views/staff/EditStaff'))
}
const rooms = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  addNew: lazy(() => import('views/rooms/AddNewRoom')),
  addbed: lazy(() => import('views/rooms/AddBed')),
  List: lazy(() => import('views/rooms/RoomsList')),
  View: lazy(() => import('views/rooms/ViewRoom')),
  Edit: lazy(() => import('views/rooms/EditRoom')),
  TenantsList: lazy(() => import('views/rooms/RoomTenantList')),
  FilledRooms: lazy(() => import('views/rooms/FilledRoom')),
  VacantsRooms: lazy(() => import('views/rooms/VacantRooms'))
}
const meters = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  List: lazy(() => import('views/MeterReading/readinglist')),
  AddNew: lazy(() => import('views/MeterReading/addreading')),
  View: lazy(() => import('views/MeterReading/ViewMeterReading')),
  Edit: lazy(() => import('views/MeterReading/EditMeterReading')),
}
const inventory = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  addNew: lazy(() => import('views/inventory/AddNewInventory')),
  List: lazy(() => import('views/inventory/InventoryList')),
  Edit: lazy(() => import('views/inventory/EditInventory'))
}
const attendance = {
  index: lazy(() => import('views/attendance/AttendancePage')),
  manualAttendance: lazy(() => import('views/attendance/ManualAttendance')),
  markHoliday: lazy(() => import('views/holidays/MarkLeave')),
  leaveList: lazy(() => import('views/holidays/LeaveList')),
  EditLeave: lazy(() => import('views/holidays/EditLeave')),
  LeaveStatus: lazy(() => import('views/holidays/LeaveStatus')),
  AttendanceList: lazy(() => import('views/attendance/AttendanceList')),
  AttendanceListLeave: lazy(() => import('views/attendance/AttendanceLeave')),
  ViewSingleAttendanceList: lazy(() => import('views/attendance/ViewSingleAttendancePage')),
}
const accounts = {
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  List: lazy(() => import('views/accounts/AccountPage')),
  Expenses: lazy(() => import('views/accounts/ExpensePage')),
  ViewExpenses: lazy(() => import('views/accounts/ExpenseView')),
  addNew: lazy(() => import('views/accounts/AddNewExpense')),
  EditExpense: lazy(() => import('views/accounts/EditExpense')),
  ExpenseType: lazy(() => import('views/accounts/ExpenseType')),
  LoanTransaction: lazy(() => import('views/accounts/LoanTransactionPage')),
}
const organization = {
  index: lazy(() => import('./views/organization/OrganizationProfile')),
  payments: lazy(() => import('./views/organization/Payments'))
}
const announcements = {
  index: lazy(() => import('./views/announcements/AnnouncementsPage'))
}
const fees = {
  index: lazy(() => import('views/apps/Apps')),
  list: lazy(() => import('views/fee/FeeList')),
  ViewLogs: lazy(() => import('views/fee/PaymentLogsList')),
  ViewSecurities: lazy(() => import('views/fee/SecurityList')),
  ClearancePage: lazy(() => import('views/fee/clearancePage')),
  ViewFee: lazy(() => import('views/fee/ViewFee')),
  ReceivedFee: lazy(() => import('views/fee/ReceivedFee')),
  ReceivableFee: lazy(() => import('views/fee/ReceivableFee')),
  AllLogs: lazy(() => import('views/fee/AllFeeLogs')),
  PerkList: lazy(() => import('views/fee/Perks')),
};
const reports = {
  dailyRegister: lazy(() => import('views/reports/DailyRegister')),
  index: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  list: lazy(() => import('views/reports/ReportsPage')),
  dailyReport: lazy(() => import('views/reports/DailyReport')),
  ViewReport: lazy(() => import('views/reports/ViewReport')),
  ViewReportByStatus: lazy(() => import('views/reports/ReportsByStatus')),
  FeeView: lazy(() => import('views/reports/FeesPage')),
  ExpenseView: lazy(() => import('views/reports/ExpensePage')),
};
const apps = {
  index: lazy(() => import('views/apps/Apps')),
  calendar: lazy(() => import('views/apps/calendar/Calendar')),
  chat: lazy(() => import('views/apps/chat/Chat')),
  contacts: lazy(() => import('views/apps/contacts/Contacts')),
  mailbox: lazy(() => import('views/apps/mailbox/Mailbox')),
  tasks: lazy(() => import('views/apps/tasks/Tasks')),
};
const auth = {
  login: lazy(() => import('views/pages/authentication/Login')),
  // forgotpassword: lazy(() => import('views/pages/authentication/Login')),
}
const setting = {
  profileSetting: lazy(() => import('views/profile/ProfileSetting')),

}


const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard`,
      component: dashboards.analytic

    },
    {
      path: `${appRoot}/login`,
      component: auth.login,
      label: '',
      icon: '',
      name: 'login',
      parent: true,

    },
    {
      path: `${appRoot}/profile-setting`,
      component: setting.profileSetting,
      label: '',
      icon: '',
      name: 'profile',
      parent: true,

    },
    {
      path: `${appRoot}/dashboard`,
      component: dashboards.analytic,
      label: 'menu.dashboard',
      icon: 'home',

    },
    {
      path: `${appRoot}/tenants`,
      label: 'menu.tenants',
      parent: true,
      name: 'tenants',
      icon: 'user',
      component: dashboards.analytic,
      subs: [
        { path: '/add-new', label: 'menu.addnew', component: tenants.addNew },
        { path: '/add-new-self/:id', label: '', component: tenants.addNewSelf },
        { path: '/list', label: 'menu.listtenant', component: tenants.List }, ///
        { path: '/active', label: '', component: tenants.ActiveTenants },
        { path: '/inactive', label: '', component: tenants.InActiveTenants },
        { path: '/view/:id', label: '', component: tenants.ViewTenant },
        { path: '/edit/:id', label: '', component: tenants.EditTenant },

      ],
    },
    {
      path: `${appRoot}/self-service`,
      label: '',
      parent: true,
      name: 'selfservice',
      icon: 'user',
      component: dashboards.analytic,
      subs: [
        // { path: '/add-new', label: 'menu.addnew', component: tenants.addNew },
        { path: '/list', label: 'menu.listtenant', component: selfservice.List }, ///
        // { path: '/active', label: '', component: tenants.ActiveTenants },
        // { path: '/inactive', label: '', component: tenants.InActiveTenants },
        // { path: '/view/:id', label: '', component: tenants.ViewTenant },
        // { path: '/edit/:id', label: '', component: tenants.EditTenant },

      ],
    },
    {
      path: `${appRoot}/shortStay`,
      label: 'menu.shortStay',
      parent: true,
      name: 'shortStay',
      icon: 'user',
      component: dashboards.analytic,
      subs: [
        { path: '/add-new', label: 'menu.addnew', component: shortStay.addNew },
        { path: '/list', label: 'menu.visitors', component: shortStay.List }, ///
        { path: '/active', label: '', component: shortStay.ActiveTenants },
        { path: '/inactive', label: '', component: shortStay.InActiveTenants },
        { path: '/view/:id', label: '', component: shortStay.ViewVisitor },
        { path: '/edit/:id', label: '', component: shortStay.EditVisitor },

      ],
    },



    {
      path: `${appRoot}/attendance`,
      label: 'menu.attendance',
      icon: 'online-class',
      name: 'attendance',
      parent: true,
      component: dashboards.analytic,
      subs: [

        { path: '/list', label: 'menu.list', component: attendance.index },
        { path: '/view/:status', label: '', component: attendance.AttendanceList },
        { path: '/tenant/view/:id', label: '', component: attendance.ViewSingleAttendanceList },
        { path: '/leave/list', label: '', component: attendance.AttendanceListLeave },
        { path: '/mark-attendance', label: 'menu.mark_attendance', component: attendance.manualAttendance },
        { path: '/mark-leave', label: '', component: attendance.markHoliday },
        { path: '/leaves', label: 'menu.leave_list', component: attendance.leaveList },
        { path: '/leave/edit/:id', label: '', component: attendance.EditLeave },
        { path: '/leave/:status', label: '', component: attendance.LeaveStatus },

      ],
    },
    {
      path: `${appRoot}/fee`,
      label: 'menu.fee',
      icon: 'dollar',
      name: 'fees',
      parent: true,
      component: dashboards.analytic,
      subs: [

        { path: '/list', label: 'menu.listfee', component: fees.list }, ///
        { path: '/clearance', label: 'menu.clearance', component: fees.ClearancePage }, ///
        { path: '/logs/:id', label: '', component: fees.ViewLogs },
        { path: '/securityList', label: 'menu.SecurityList', component: fees.ViewSecurities },
        { path: '/fee-perks', label: 'menu.perks', component: fees.PerkList },
        { path: '/receivable-fee', label: '', component: fees.ReceivableFee },
        { path: '/received-fee', label: '', component: fees.ReceivedFee },
        { path: '/all-logs', label: '', component: fees.AllLogs },
        { path: '/view/:id', label: '', component: fees.ViewFee },

      ],
    },
    {
      path: `${appRoot}/accounts`,
      label: 'menu.accounts',
      icon: 'laptop',
      parent: true,
      name: 'accounts',
      component: dashboards.analytic,
      subs: [

        { path: '/expense/add-new', label: '', component: accounts.addNew },

        { path: '/expense', label: 'menu.expenses', component: accounts.Expenses },
        { path: '/view/:expenseId', label: '', component: accounts.ViewExpenses },
        { path: '/edit/:id', label: '', component: accounts.EditExpense },
        { path: '/type/:state', label: '', component: accounts.ExpenseType },
        { path: '/loan', label: 'menu.loan_transaction', component: accounts.LoanTransaction },


      ],
    },


    {
      path: `${appRoot}/reports`,
      label: 'menu.reports',
      icon: 'duplicate',
      parent: true,
      name: 'reports',
      component: dashboards.analytic,
      subs: [

        { path: '/daily-report', label: '', component: reports.dailyReport },
        { path: '/list', label: 'menu.listreports', component: reports.list }, ///
        { path: '/view/:id', label: '', component: reports.ViewReport },
        { path: '/type/:type', label: '', component: reports.ViewReportByStatus },
        { path: '/feeView', label: '', component: reports.FeeView },
        { path: '/expenseView', label: '', component: reports.ExpenseView },
        { path: '/dailyLedger', label: '', component: reports.dailyRegister },

      ],
    },

    {
      path: `${appRoot}/organization`,
      label: 'menu.organization',
      icon: 'building-large',
      parent: true,
      name: 'organization',
      component: organization.index,
      subs: [

        { path: '/profile', label: 'menu.organization', component: organization.index },
        { path: '/payments', label: 'menu.payments', component: organization.payments },

      ],
    },
    {
      path: `${appRoot}/rooms`,
      label: 'menu.property',
      icon: 'building',
      name: 'rooms',
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: '/add-new', label: 'menu.addnew', component: rooms.addNew },
        { path: '/add-bed', label: 'menu.bed', component: rooms.addbed },
        { path: '/filled', label: '', component: rooms.FilledRooms },
        { path: '/vacants', label: '', component: rooms.VacantsRooms },
        { path: '/list', label: 'menu.listrooms', component: rooms.List }, ///
        { path: '/view/:id', label: '', component: rooms.View },
        { path: '/edit/:id', label: '', component: rooms.Edit },
        { path: '/tenant/list/:id', label: '', component: rooms.TenantsList },

      ],
    },
    {
      path: `${appRoot}/meters`,
      label: 'menu.meters',
      icon: 'dashboard-1',
      name: 'meters',
      parent: true,
      component: dashboards.analytic,
      subs: [

        { path: '/view/:id', label: '', component: meters.View },
        { path: '/add-new', label: 'menu.addnew', component: meters.AddNew },
        { path: '/list', label: 'menu.list', component: meters.List }, ///
        { path: '/edit/:id', label: '', component: meters.Edit },

      ],
    },
    {
      path: `${appRoot}/inventory`,
      label: 'menu.assets',
      icon: 'invoice',
      name: 'inventory',
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: '/add-new', label: 'menu.addnew', component: inventory.addNew },
        { path: '/list', label: 'menu.listinventory', component: inventory.List }, ///
        { path: '/edit/:id', label: '', component: inventory.Edit },

      ],
    },
    {
      path: `${appRoot}/staff`,
      label: 'menu.staff',
      icon: 'user',
      name: 'staff',
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: '/add-new', label: 'menu.addnew', component: staff.addNew },
        { path: '/list', label: 'menu.listStaff', component: staff.List }, ///
        { path: '/view/:id', label: '', component: staff.ViewList },
        { path: '/edit/:id', label: '', component: staff.Edit },

      ],
    },
    {
      path: `${appRoot}/push-notification`,
      label: 'menu.announcements',
      icon: 'bell',
      parent: true,
      name: 'announcements',
      component: announcements.index,
    },

  ],
  sidebarItems: [
    { path: '#connections', label: 'menu.connections', icon: 'diagram-1', hideInRoute: true },
    { path: '#bookmarks', label: 'menu.bookmarks', icon: 'bookmark', hideInRoute: true },
    { path: '#requests', label: 'menu.requests', icon: 'diagram-2', hideInRoute: true },
    {
      path: '#account',
      label: 'menu.account',
      icon: 'user',
      hideInRoute: true,
      subs: [
        { path: '/settings', label: 'menu.settings', icon: 'gear', hideInRoute: true },
        { path: '/password', label: 'menu.password', icon: 'lock-off', hideInRoute: true },
        { path: '/devices', label: 'menu.devices', icon: 'mobile', hideInRoute: true },
      ],
    },
    {
      path: '#notifications',
      label: 'menu.notifications',
      icon: 'notification',
      hideInRoute: true,
      subs: [
        { path: '/email', label: 'menu.email', icon: 'email', hideInRoute: true },
        { path: '/sms', label: 'menu.sms', icon: 'message', hideInRoute: true },
      ],
    },
    {
      path: '#downloads',
      label: 'menu.downloads',
      icon: 'download',
      hideInRoute: true,
      subs: [
        { path: '/documents', label: 'menu.documents', icon: 'file-text', hideInRoute: true },
        { path: '/images', label: 'menu.images', icon: 'file-image', hideInRoute: true },
        { path: '/videos', label: 'menu.videos', icon: 'file-video', hideInRoute: true },
      ],
    },
  ],
};
export default routesAndMenuItems;
